export const JACKPOT_STATE = {
    URGENT: 'urgent',
    TICKING: 'ticking',
    JUST_WON: 'justwon',
    HIDDEN: 'hidden',
    INVALID: 'invalid'
};
